import { Injectable, inject } from '@angular/core';

import { ConstantsService } from './constants.service';

@Injectable()
export class ApiConstantsService {
  private _constantsService = inject(ConstantsService);

  // Micro services
  get identityMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/identity/v1/rest`;
  }

  get legacyManagerMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/legacy-manager/v1/rest`;
  }

  get stickerManagerMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/sticker-manager/v1/rest`;
  }

  get auditorMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/auditor/v1/rest`;
  }

  get invoiceManagerMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/invoice-manager/v1/rest`;
  }

  get sequenceRuleManagerMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/sequence-rule-manager/v1/rest`;
  }

  get coreManagerMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/core-manager/v1/rest`;
  }

  get statisticManagerMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/statistic-manager/v1/rest`;
  }

  get receiptMicroservice(): string {
    return `${this._constantsService.environment.apiUrl}/receipt-manager/v1/rest`;
  }

  // Organization
  get organizationUrl(): string {
    return `${this.identityMicroservice}/organizations`;
  }

  get taxRulesUrl(): string {
    return `${this.coreManagerMicroservice}/rules`;
  }

  get taxesUrl(): string {
    return `${this.coreManagerMicroservice}/taxes`;
  }

  get taxTypesUrl(): string {
    return `${this.coreManagerMicroservice}/tax-types`;
  }

  get taxProfilesUrl(): string {
    return `${this.identityMicroservice}/tax-profiles`;
  }

  // Audit
  get auditUrl(): string {
    return `${this.auditorMicroservice}/audits`;
  }

  // User

  get rolesUrl(): string {
    return `${this.identityMicroservice}/roles`;
  }

  get accountUrl(): string {
    return `${this.identityMicroservice}/accounts`;
  }

  get logoutUrl(): string {
    return `${this._constantsService.environment.apiUrl}/identity/logout`;
  }

  get profileUrl(): string {
    return `${this.identityMicroservice}/me`;
  }

  get updateUserEmailUrl(): string {
    return `${this.profileUrl}/fields/email/update/request`;
  }

  get tokensUrl(): string {
    return `${this.identityMicroservice}/auth/tokens`;
  }

  get apiTokensUrl(): string {
    return `${this.identityMicroservice}/api-keys`;
  }

  get otpUrl(): string {
    return `${this.identityMicroservice}/otps`;
  }

  get usersUrl(): string {
    return `${this.identityMicroservice}/users`;
  }

  get preferencesUrl(): string {
    return `${this.profileUrl}/preference`;
  }

  get companyUrl(): string {
    return `${this.legacyManagerMicroservice}/companies`;
  }

  get referenceDataUrl(): string {
    return `${this.legacyManagerMicroservice}/reference-data`;
  }

  get importTaskUrl(): string {
    return `${this.auditorMicroservice}/import-tasks`;
  }

  get ResultTaskUrl(): string {
    return `${this.auditorMicroservice}/result-tasks`;
  }

  // Establishment
  get establishmentsUrl(): string {
    return `${this.identityMicroservice}/establishments`;
  }

  // Sales Point
  get salesPointsUrl(): string {
    return `${this.identityMicroservice}/sales-points`;
  }

  // Customer Supplier
  get customerSupplierUrl(): string {
    return `${this.identityMicroservice}/customer-suppliers`;
  }

  // Partners
  get partnerUrl(): string {
    return `${this.identityMicroservice}/partners`;
  }

  // stickers
  get stickersUrl(): string {
    return `${this.stickerManagerMicroservice}/stickers`;
  }

  // Billing AddressUrl
  get billingAddressUrl(): string {
    return `${this.identityMicroservice}/billing-addresses`;
  }

  // Billing Terminals
  get billingTerminalsUrl(): string {
    return `${this.identityMicroservice}/billing-terminals`;
  }

  get organizationStickersUrl(): string {
    return `${this.stickerManagerMicroservice}/stickers/balance`;
  }

  get stickerConsumptionsUrl(): string {
    return `${this.stickerManagerMicroservice}/sticker-consumptions`;
  }

  get stickerMovementsUrl(): string {
    return `${this.stickerManagerMicroservice}/sticker-movements`;
  }

  // Establishment
  get receiptsUrl(): string {
    return `${this.receiptMicroservice}/receipts`;
  }

  // payments
  get paymentsUrl(): string {
    return `${this.stickerManagerMicroservice}/payments`;
  }

  get paymentCheckoutUrl(): string {
    return `${this.stickerManagerMicroservice}/payments/checkout`;
  }

  // invoices
  get invoicesUrl(): string {
    return `${this.invoiceManagerMicroservice}/invoices`;
  }

  get invoiceManagerV2Microservice(): string {
    return `${this._constantsService.environment.apiUrl}/invoice-manager/v2/rest`;
  }

  get invoicesV2Url(): string {
    return `${this.invoiceManagerV2Microservice}/invoices`;
  }

  // sequence rules
  get sequenceRulesUrl(): string {
    return `${this.sequenceRuleManagerMicroservice}/sequence-rules`;
  }

  // statistic
  get statisticUrl(): string {
    return `${this.statisticManagerMicroservice}`;
  }

  // dashboard
  get dashboardUrl(): string {
    return `${this.statisticManagerMicroservice}/dashboards`;
  }

  get supersetUrl(): string {
    return `${this.statisticManagerMicroservice}/superset`;
  }

  // currencies
  get currenciesUrl(): string {
    return `${this.coreManagerMicroservice}/currencies`;
  }

  get conversionRatesUrl(): string {
    return `${this.coreManagerMicroservice}/conversion-rates`;
  }

  get organizationFiltersValuesUrl(): string {
    return `${this.legacyManagerMicroservice}/companies/filter/values`;
  }

  get configurationUrl(): string {
    return `${this.identityMicroservice}/configurations`;
  }

  // Exemption

  get beneficiaryCategoryUrl(): string {
    return `${this.coreManagerMicroservice}/beneficiary-categories`;
  }

  get taxExemptionTypeUrl(): string {
    return `${this.coreManagerMicroservice}/tax-exemption-types`;
  }

  get declaredTaxExemptionsUrl(): string {
    return `${this.coreManagerMicroservice}/declared-tax-exemptions
`;
  }
}
